import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
};

const removeOrderElements = (list, orderCode) => {
  return list.filter((order) => order.orderCode !== orderCode);
};

export const providerOrdersAuthorization = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.GET_PROVIDER_ORDERS_AUTHORIZATION_LIST_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_AUTHORIZATION_LIST_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.GET_PROVIDER_ORDERS_AUTHORIZATION_LIST_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.REJECT_PROVIDER_ORDER_AUTHORIZATION_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.REJECT_PROVIDER_ORDER_AUTHORIZATION_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': removeOrderElements(state.list, action.payload),
    }),
    [ActionTypes.REJECT_PROVIDER_ORDER_AUTHORIZATION_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.AUTHORIZE_PROVIDER_ORDER_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.AUTHORIZE_PROVIDER_ORDER_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': removeOrderElements(state.list, action.payload),
    }),
    [ActionTypes.AUTHORIZE_PROVIDER_ORDER_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
  })(state, action);
};
